var map = {
	"./account.svg": "0bce",
	"./add-geometry.svg": "c9aa",
	"./arrow-down.svg": "f10f",
	"./arrow-left.svg": "0e31",
	"./arrow-right.svg": "89b1",
	"./attribute-table-add.svg": "0283",
	"./attribute-table.svg": "b08b",
	"./base-layer.svg": "b515",
	"./calendar.svg": "59e8",
	"./camera.svg": "1f1e",
	"./check.svg": "fdcd",
	"./circle-check-outline.svg": "1507",
	"./circle-error-outline.svg": "8b5a",
	"./circle-error.svg": "c79e",
	"./circle-i-outline.svg": "8b7e",
	"./circle-x.svg": "62a8",
	"./compass.svg": "64ca",
	"./crop.svg": "972b",
	"./dash.svg": "4aaa",
	"./delete.svg": "e6f1",
	"./delete_forever.svg": "71b4",
	"./dot.svg": "74d8",
	"./download.svg": "db4e",
	"./edit-geometry.svg": "c33b",
	"./edit.svg": "1e8b",
	"./exit_to_app.svg": "8076",
	"./filter.svg": "9a95",
	"./filter_list.svg": "dada",
	"./first_page.svg": "0e43",
	"./identification.svg": "835d",
	"./image-size.svg": "2cdd",
	"./last_page.svg": "041d",
	"./legend.svg": "7440",
	"./line.svg": "9a42",
	"./lock.svg": "841b",
	"./magnifier.svg": "7a57",
	"./map_off.svg": "695d",
	"./menu-dots.svg": "c390",
	"./menu.svg": "181e",
	"./minus.svg": "6e38",
	"./navigate_before.svg": "d462",
	"./navigate_next.svg": "bb1d",
	"./node-tool.svg": "53d7",
	"./opacity.svg": "920f",
	"./overlays.svg": "849c",
	"./photo.svg": "66d3",
	"./plus.svg": "6a30",
	"./point.svg": "c2bf",
	"./polygon.svg": "8d4e",
	"./printer.svg": "a0ae",
	"./qgis.svg": "810d",
	"./raster.svg": "2c84",
	"./reset_filter.svg": "2d91",
	"./restore.svg": "03fa",
	"./ruler.svg": "8516",
	"./save.svg": "e5aa",
	"./settings.svg": "4ccf",
	"./target.svg": "3ddb",
	"./topics.svg": "acbb",
	"./tune.svg": "a9ed",
	"./visibility.svg": "3d4b",
	"./visibility_off.svg": "3dc1",
	"./warning.svg": "b710",
	"./x.svg": "9954",
	"./zoom-max.svg": "d601",
	"./zoom-to.svg": "11fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e91";